import { render, staticRenderFns } from "./ResourceManage.vue?vue&type=template&id=4724fca8&scoped=true"
import script from "./ResourceManage.vue?vue&type=script&lang=js"
export * from "./ResourceManage.vue?vue&type=script&lang=js"
import style0 from "./ResourceManage.vue?vue&type=style&index=0&id=4724fca8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4724fca8",
  null
  
)

export default component.exports